import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hulk-config-tailwindcss',
  templateUrl: './hulk-config-tailwindcss.component.html',
  styleUrls: ['./hulk-config-tailwindcss.component.scss']
})
export class HulkConfigTailwindcssComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
